import { useMemo } from 'react';
import { KeyInsightsSectionsKit } from './types/keyInsightsSectionKit.types';
import useKeyInsightsSectionsKit from './useKeyInsightsSectionsKit';

// Keyed by category name (the section's display_title). Shares the underlying
// query cache, so the data is fetched once no matter how many surfaces consume it.
export default function useCategorySectionEvaluations(kitId?: string) {
  const { data } = useKeyInsightsSectionsKit(kitId);

  return useMemo(() => {
    const evaluationsByCategoryName = new Map<string, KeyInsightsSectionsKit>();

    for (const item of data ?? []) {
      const categoryName = item.section?.display_title;
      if (!categoryName || evaluationsByCategoryName.has(categoryName)) continue;

      evaluationsByCategoryName.set(categoryName, item);
    }

    return evaluationsByCategoryName;
  }, [data]);
}
